<template>
  <quill-editor
    ref="editor"
    class="d-flex flex-column flex-grow-1"
    @input="updateValue"
    content-type="delta"
    @focus="handleToggleActiveClassCallback"
    @blur="handleToggleActiveClassCallback"
    v-bind="{ value: internalHtml, disabled }"
    :options="quillOptions"/>
</template>

<script>
import { quillEditor as QuillEditor } from 'vue-quill-editor'

export default {
  props: {
    value: [String, Object],
    disabled: Boolean,
    hasToken: {
      type: Boolean,
      required: false,
      default: true
    },
    format: {
      type: String,
      required: false,
      default: 'html'
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  components: {
    QuillEditor
  },

  computed: {
    quillOptions () {
      return this.defaultOptions
    }
  },

  data () {
    return {
      internalHtml: '',
      deltaValue: null,
      applyProp: false,
      pendingValue: null,
      defaultOptions: {
        placeholder: null,
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              ['bold', 'italic', 'underline'],
              ['link'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              this.hasToken ? [{
                token: [
                  '{ first_name }',
                  '{ device_name }',
                  '{ org_name }',
                  '{ dept_name }',
                  '{ dept_contact }',
                  '{ low_battery_users }',
                  '{ btn_user_profile }',
                  '{ btn_user_setup }'
                ]
              }] : [],
            ],
            handlers: {
              token: function (value) {
                if (value) {
                  const cursorPosition = this.quill.getSelection().index
                  this.quill.insertText(cursorPosition, value)
                  this.quill.setSelection(cursorPosition + value.length)
                }
              }
            }
          }
        }
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (!this.$refs.editor?.quill) {
          this.pendingValue = val
          return
        }
        this.applyFromProp(val)
      }
    }
  },

  mounted () {
    // Manually supply the HTML content of our custom dropdown list
    const tokenPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-token .ql-picker-item'))
    tokenPickerItems.forEach((item) => {
      item.textContent = item.dataset.value
    })

    if (this.hasToken) {
      document.querySelector('.ql-token .ql-picker-label').innerHTML = 'Insert Token' + document.querySelector('.ql-token .ql-picker-label').innerHTML
      document.querySelector('.ql-token').parentNode.classList.add('ms-auto', 'me-0')
    }
  },

  methods: {
    getQuil () {
      return this.$refs.editor.quill ?? null
    },

    applyFromProp (val) {
      this.applyProp = true
      const quill = this.getQuil()
      try {
        if (quill) {
          if (this.format === 'delta') {
            const cursorPosition = quill.getSelection()
            quill.setContents(val)
            if (cursorPosition) {
              quill.setSelection(cursorPosition.index)
            }
          }
        }
      } finally {
        this.applyProp = false
      }
    },

    updateValue (value) {
      if (!this.applyProp) {
        const newValue = this.format === 'delta' ? this.getQuil().getContents() : value
        this.$emit('input', newValue)
      }
    },

    /**
     * Toggle the active class on the the quill text editor
     */
    handleToggleActiveClassCallback () {
      if (this.$refs.editor.quill.hasFocus()) {
        this.$refs.editor.$el.classList.add('active')
      } else {
        this.$refs.editor.$el.classList.remove('active')
      }
    }
  }
}
</script>
